import React, { Component } from 'react';
import {
  Modal, Label, Checkbox, Popup, List
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
//import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import searchIcon from '../../images/common/search_icon.png';

class AssigningProjectModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMAP: props.isOpenMAP,
      isOpenMCU: props.isOpenMCU,
      isOpenMEU: props.isOpenMEU,
      isOpenMCG: props.isOpenMCG,
      isOpenMEG: props.isOpenMEG,
      isOpen: false,
      searchKeyword: '',
      errSearch: false,
      isFocus: false,
      itemsChecked: false,
      selectedUsers: props.selectedUsers || [],
      checkValue: [],
      projectList: [],
      excludeIds: [],
      activeIndex: '',
      memberList: [],
      memberPopup: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleProjectMemberChange = this.handleProjectMemberChange.bind(this);
    this.handleProjectCheckAll = this.handleProjectCheckAll.bind(this);
    this.handleSearchProject = this.handleSearchProject.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMAP, selectedUsers, projects } = this.props;

    if (prevProps.isOpenMAP !== isOpenMAP) {
      this.setState({
        isOpenMAP,
        checkValue: [],
        selectedUsers: [],
        projectList: [],
        excludeIds: [],
        itemsChecked: false,
        activeIndex: '',
        memberList: [],
        memberPopup: false,
      }, () => {
        if (isOpenMAP) {
          this.searchProject();
        }
      });
    }

    if (selectedUsers && prevProps.selectedUsers !== selectedUsers) {
      this.setState({
        selectedUsers,
      });
    }

    if (projects && prevProps.projects.length !== projects.length) {
      const newIds = [];
      projects.map((item) => {
        return newIds.push(item.id);
      });
      this.setState(
        {
          excludeIds: newIds,
        },
        () => {
          this.searchProject();
        }
      );
    }
  }

  handleSave() {
    const { projectList, checkValue } = this.state;
    const { closeModal, completeCallback } = this.props;
    if (checkValue.length === 0) {
      this.setState({
        isOpen: true,
      });
      return false;
    }
    const selectedArr = projectList.filter((item) => {
      return checkValue.indexOf(item.id) > -1;
    });
    this.setState({
      isOpenMAP: false,
    });
    closeModal();
    completeCallback(selectedArr);
  }

  handleProjectMemberChange(e) {
    this.setState({
      searchKeyword: e.target.value,
    });
  }

  handleSearchProject(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      this.setState(
        {
          projectList: [],
        },
        () => {
          this.searchProject();
          setTimeout(() => {
            this.setState({
              isFocus: false,
            });
          }, 1500);
        }
      );
    }
  }

  handleCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;

    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleProjectCheckAll() {
    const { itemsChecked, projectList } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      const num = projectList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(projectList[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }

  handleFocus() {
    this.setState({
      isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      isFocus: false,
    });
  }

  handlePopupClose() {
    this.setState({
      memberPopup: false,
      activeIndex: '',
      memberList: [],
    });
  }

  onSubmit() {
    const { checkValue, selectedUsers } = this.state;
    const { closeModal, completeCallback } = this.props;
    let i = 0;
    const userIdsArr = [];

    if (checkValue.length === 0) {
      this.setState({
        isOpen: true,
      });
      return false;
    }
    for (i; i < selectedUsers.length; i++) {
      userIdsArr.push(selectedUsers[i].uid);
    }

    api
      .saveUserProject({
        user_ids: userIdsArr,
        project_ids: checkValue,
      })
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            isOpenMAP: false,
          });
          closeModal();
          completeCallback(200);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  closeErrorModal() {
    this.setState({
      isOpen: false,
    });
  }

  closeModal() {
    const { closeModal } = this.props;
    this.setState({
      isOpenMAP: false,
    });
    closeModal();
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        projectList: [],
      },
      () => {
        this.searchProject();
      }
    );
  }

  searchProject() {
    const { searchKeyword, excludeIds } = this.state;

    if (excludeIds.length !== 0) {
      api
        .searchProject({
          search: searchKeyword,
          exclude_ids: excludeIds,
        })
        .then((response) => {
          if (response.count === 0) return;

          this.setState({
            projectList: response.response,
          });
        });
    } else {
      api
        .searchProject({
          search: searchKeyword,
        })
        .then((response) => {
          if (response.count === 0) return;

          this.setState({
            projectList: response.response,
          });
        });
    }
  }

  renderColumn(obj) {
    const {
      isOpenMEG, isOpenMCG, memberPopup, activeIndex, memberList
    } = this.state;
    if (isOpenMEG || isOpenMCG) {
      if (obj.group_count !== 0) {
        return (
          <Popup
            trigger={<span style={{ cursor: 'pointer' }}>{obj.group_count}</span>}
            on="click"
            hideOnScroll
            position="bottom left"
            open={memberPopup && activeIndex === obj.id}
            onOpen={() => {
              return this.renderPopup(obj.id, obj.groups);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                memberList.map((list) => {
                  return (
                    <List.Item key={uuidv4()}>
                      <List.Icon name="group" />
                      <List.Content>{list}</List.Content>
                    </List.Item>
                  );
                })
              }
            </List>
          </Popup>
        );
      }
      return (
        <span>{obj.group_count}</span>
      );
    }

    if (obj.member_count !== 0) {
      return (
        <Popup
          trigger={<span style={{ cursor: 'pointer' }}>{obj.member_count}</span>}
          on="click"
          hideOnScroll
          position="bottom left"
          open={memberPopup && activeIndex === obj.id}
          onOpen={() => {
            return this.renderPopup(obj.id);
          }}
          onClose={this.handlePopupClose}
        >
          <List>
            {
              memberList.map((list) => {
                return (
                  <List.Item key={uuidv4()}>
                    <List.Icon name="user" />
                    <List.Content>{list}</List.Content>
                  </List.Item>
                );
              })
            }
          </List>
        </Popup>
      );
    }
    return (
      <span>{obj.member_count}</span>
    );

  }

  renderPopup(id, groups) {
    if (typeof groups !== 'undefined') {
      this.setState({
        memberPopup: true,
        activeIndex: id,
        memberList: groups,
      });
    } else {
      api
        .getSProjectMemberDetail(id)
        .then((response) => {
          const data = response.response;
          this.setState({
            memberPopup: true,
            activeIndex: id,
            memberList: data.member_list,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  render() {
    const {
      searchKeyword,
      errSearch,
      isFocus,
      selectedUsers,
      projectList,
      checkValue,
      itemsChecked,
      isOpenMAP,
      isOpenMEG,
      isOpenMCG,
      isOpenMCU,
      isOpenMEU,
      isOpen
    } = this.state;
    const { translate } = this.props;

    return (
      <Modal open={isOpenMAP} onClose={this.closeModal}>
        <div className="setting_popup_wrap">
          <div className="setting_popup applying_policy">
            <div className="popup_scroll">
              <div className="setting_popup_header">
                <h2 className="popup_name">
                  {translate('modal.title.assigning_project')}
                  <em>
                    {selectedUsers.length === 1 && selectedUsers[0].userName}
                    {selectedUsers.length === 0 ? '' : `${selectedUsers.length} users`}
                  </em>
                </h2>
                <a
                  className="popup_close_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <div className="setting_popup_content">
                    <div className="search_box">
                      <span className="search_icon">
                        <img src={searchIcon} alt="" />
                      </span>
                      <input
                        type="text"
                        value={searchKeyword}
                        placeholder={translate('modal.title.label_project_name_owner')}
                        onChange={this.handleProjectMemberChange}
                        onKeyPress={this.handleSearchProject}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                      />
                      <a
                        className="reset_icon"
                        onClick={this.clearSearch}
                        onKeyUp={this.clearSearch}
                      >
                        x
                      </a>
                      {errSearch && (
                        <Label basic color="red" pointing>
                          {translate('contents_header.message.least_two_required_to_search')}
                        </Label>
                      )}
                      {isFocus && <Label pointing>{translate('modal.title.label_project_name_owner')}</Label>}
                    </div>
                  </div>
                  <div className="setting_popup_content">
                    <div className="table_wrap table_type_3" style={{ height: '415px' }}>
                      <Scrollbars>
                        <table className="table table_type_3">
                          <colgroup>
                            <col style={{ width: '36px' }} />
                            <col style={{ width: '' }} />
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '20%' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <th>
                                <Checkbox
                                  checked={itemsChecked}
                                  onChange={this.handleProjectCheckAll}
                                />
                              </th>
                              <th>{translate('modal.title.project_name')}</th>
                              <th>
                                {isOpenMEG || isOpenMCG
                                  ? translate('modal.title.project_group')
                                  : translate('modal.title.project_member')}
                              </th>
                              <th>{translate('modal.title.project_owner')}</th>
                            </tr>
                            {projectList.length !== 0
                              ? projectList.map((item) => {
                                return (
                                  <tr key={uuidv4()}>
                                    <td>
                                      <Checkbox
                                        value={item.id}
                                        checked={checkValue.indexOf(item.id) > -1}
                                        onChange={this.handleCheckChange}
                                      />
                                    </td>
                                    <td className="strong" style={{ maxWidth: '310px' }}>{item.name}</td>
                                    <td className="strong" style={{ textAlign: 'center' }}>
                                      {this.renderColumn(item)}
                                    </td>
                                    <td className="strong" style={{ textAlign: 'center' }}>
                                      {item.owner}
                                    </td>
                                  </tr>
                                );
                              })
                              : null}
                          </tbody>
                        </table>
                      </Scrollbars>
                    </div>
                  </div>
                </div>
                <div className="setting_popup_button_wrap">
                  <a
                    className="button cencel_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {translate('modal.button.cancel')}
                  </a>
                  <a
                    className="button save_button"
                    style={{ cursor: 'pointer' }}
                    onClick={
                      isOpenMCU
                      || isOpenMEU
                      || isOpenMCG
                      || isOpenMEG
                        ? this.handleSave
                        : this.onSubmit
                    }
                    onKeyUp={
                      isOpenMCU
                      || isOpenMEU
                      || isOpenMCG
                      || isOpenMEG
                        ? this.handleSave
                        : this.onSubmit
                    }
                  >
                    {translate('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal open={isOpen} onClose={this.closeErrorModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">{translate('modal.message.select_one_project')}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeErrorModal}
                    onKeyUp={this.closeErrorModal}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default inject('state')(observer(AssigningProjectModal));
